import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { getPaySystemName } from '../../../../../../../../utils/cashier';

import {
  TXTWCL_To_complete_your_N0_deposit_yo_ELL,
  TXTWCL_WeXve_sent_N0Xs_details_to_N1X
} from './Multibanco.messages.json';
import MultibancoInfoBox from './MultibancoInfoBox/MultibancoInfoBox';

interface Props {
  userEmail?: string;
  amount: number;
  currency: Currency;
  cardType: number;
}

const Multibanco: React.FC<Props> = ({ userEmail, amount, currency, cardType }) => {
  const {
    data: { paySystems = [] }
  } = useWizardContext();

  const i18nSystemName = getPaySystemName(paySystems, cardType);

  return (
    <>
      <Translation
        tagName="p"
        {...TXTWCL_WeXve_sent_N0Xs_details_to_N1X}
        values={{ 0: i18nSystemName, 1: <b>{userEmail}</b> }}
      />
      <Translation
        tagName="p"
        {...TXTWCL_To_complete_your_N0_deposit_yo_ELL}
        values={{ 0: i18nSystemName }}
      />
      <MultibancoInfoBox depositAmount={amount} depositCurrency={currency} />
    </>
  );
};

export default Multibanco;
